<template>
<div class="sa-video-call">
    <div :class=" isLocalAsPrimary ?'sa-remote':'sa-local'" id="remoteTrack" @click="isLocalAsPrimary? minMaxPanel() : ''" />
    <div :class="enableLocalFrame ? '' : '' ">
        <div :class="!isLocalAsPrimary ?'sa-remote':'sa-local'" id="localTrack" @click="!isLocalAsPrimary?minMaxPanel() : ''" />
    </div>
    <controls />
    <i class="icon-maximize" @click="changeMinimized" :class="minimized?'sa-maxi':'sa-d-none'"></i>
</div>
</template>

<script>
import Twilio, {
    createLocalVideoTrack
} from 'twilio-video';
import {
    com_url
} from "../../../../config/endpoints";
import {
    mapGetters
} from 'vuex';
// import { CALL_STATUS } from '../../../util/common';
import {
    bus
} from '../../../main';
const Controls = () => import( /* webpackChunkName: "controls" */ "../Controls.vue");

export default {
    name: "TwilioClient",
    components: {
        Controls
    },
    data() {
        return {
            message: "loading screen..",
            loading: true,
            videoRoom: null,
            participant: null,
            isLocalAsPrimary: false,
            localControls: {
                muted: true,
                video: true,
                audio: false,
            },
            cameraMode: 'user',
            minimized: false,
            enableLocalFrame: false
        }
    },
    computed: {
        ...mapGetters({
            videocallPayload: "videocallPayload"
        }),
        timerUpdate() {
            return this.$parent.timer
        }
    },
    created() {
        console.log('twilio client component initiated');
    },
    async mounted() {
        console.log('videocall playload : ', this.videocallPayload);
        const connectOptions = {
            name: this.videocallPayload.roomName,
            audio: true,
        };
        let secToken
        let userInfo = JSON.parse(this.$localStorage.get("userdata"))
        await this.$store
            .dispatch("httpPost", {
                uri: `${com_url}/videocall/get-access-token`,
                body: {
                    username: userInfo.uid,
                    roomname: this.videocallPayload.roomName,
                },
            })
            .then(res => {
                secToken = res.data.token
            })
        // this.$parent.clearTimer()
        Twilio.connect(secToken, connectOptions)
            .then(room => {
                console.log('room : ', room);
                this.videoRoom = room;
                room.participants.forEach(participant => {
                    this.participant = participant;
                    const previewContainer = document.getElementById("remoteTrack");
                    // track subscription
                    this.participant.on("trackSubscribed", track => {
                        console.log('track ', track);
                        trackSubscribe(previewContainer, track);
                    });
                    // track un-subscription
                    this.participant.on("trackUnsubscribed", trackUnsubscribed);
                    this.participant.tracks.forEach(publication => {
                        if (publication.isSubscribed) {
                            trackSubscribe(previewContainer, publication.track);
                        }
                    })
                });

                room.on("participantConnected", participant => {
                    this.$parent.setTimer()
                    this.disableLocalVideo()
                    this.enableLocalFrame = true
                    this.participant = participant;
                    const previewContainer = document.getElementById("remoteTrack");
                    this.participant.on("trackSubscribed", track => {
                        trackSubscribe(previewContainer, track);
                    });
                    this.participant.tracks.forEach(publication => {
                        if (publication.isSubscribed) {
                            if (track && track.kind != "data") {
                                trackSubscribe(previewContainer, track);
                            }
                        }
                    });
                    // this.$store.dispatch('socket/SET_NEW_MSG_FLAG', false);
                    // this.$store.dispatch('videocall/UPDATE_CALL_STATUS', CALL_STATUS.CONNECTED);
                });

                createLocalVideoTrack()
                    .then(track => {
                        if (track) {
                            const localMediaContainer = document.getElementById("localTrack");
                            if (track.kind == 'video') {
                                // track.disable();
                            }
                            localMediaContainer.appendChild(track.attach());
                            room.localParticipant.publishTrack(track);
                        }
                    });
            });
        // track subscribe
        async function trackSubscribe(div, track) {
            console.log('tracks ', track)
            if (track) {
                let ele = document.createElement('audio');
                ele.id = 'remoteParticipantAudio';
                if (track.kind == 'video') {
                    ele = document.createElement('video');
                    ele.id = 'remoteParticipantVideo';
                }
                console.log('before attach ', track);
                await track.attach(ele);
                console.log('attach done');
                const remoteTrack = document.getElementById('remoteTrack');
                const videoElement = document.getElementById('remoteParticipantVideo');
                if (videoElement) {
                    remoteTrack.removeChild(videoElement);
                }
                remoteTrack.appendChild(ele);
            }
        };
        // track unsubscribe
        const trackUnsubscribed = async (track) => {
            // detaching video tracks
            if (track && track.kind == "video") {
                if (track.mediaStreamTrack.readyState == "ended") {
                    // this.$store.dispatch('videocall/UPDATE_CALL_STATUS', CALL_STATUS.DISCONNECTED);
                }
                if (track.mediaStreamTrack.readyState === "ended") {
                    if ([...this.videoRoom.localParticipant.videoTracks.values()][0].track) {
                        const videoTrack = [
                            ...this.videoRoom.localParticipant.videoTracks.values()
                        ][0].track;
                        videoTrack.stop();
                        videoTrack.detach().forEach(element => element.remove());
                        videoTrack.stop();

                        this.videoRoom.localParticipant.unpublishTrack(videoTrack);
                        track.detach().forEach(element => element.remove());
                    }
                }
            }
            // detaching audio tracks
            if (track && track.kind == "audio") {
                if (track.mediaStreamTrack.readyState === "ended") {
                    // this.$store.dispatch('videocall/UPDATE_CALL_STATUS', CALL_STATUS.DISCONNECTED);
                }
                const audioTrack = [
                    ...this.videoRoom.localParticipant.audioTracks.values()
                ][0].track;
                audioTrack.stop();
                audioTrack.detach().forEach(element => element.remove());
                this.videoRoom.localParticipant.unpublishTrack(audioTrack);
                track.detach().forEach(element => element.remove());
            }
        };
        // end call
        this.$on('onDisconnect', this.leaveCall);
        // mute local audio
        this.$on('onMute', this.mute);
        // mute remote video
        this.$on('disableSpeaker', this.disableRemoteSpeaker);
        // disable local video
        this.$on('onVideo', this.disableLocalVideo);
        // flip camera
        this.$on('camerasChanged', this.switchCamera)
        // chat button pressed to minimize the video layer
        this.$on('onChat', this.onCHat)
    },
    methods: {
        async leaveCall() {
            // this.$store.dispatch('socket/SET_DURATION', this.$parent.timer);
            this.$parent.clearTimer()
            console.log('disconnecting call');
            const videoTrack = this.videoRoom.localParticipant && [...this.videoRoom.localParticipant.videoTracks.values()];
            videoTrack.forEach(async publication => {
                await publication.track.stop();
                await this.videoRoom.disconnect();
            });
            bus.$emit("endCall");
            // this.$store.dispatch('videocall/UPDATE_CALL_STATUS', CALL_STATUS.DISCONNECTED);
        },
        mute() {
            this.videoRoom.localParticipant.audioTracks.forEach(publication => {
                !this.localControls.muted ? publication.track.disable() : publication.track.enable();
            });
            this.localControls.muted = !this.localControls.muted;
        },
        disableRemoteSpeaker() {
            let ele = document.getElementById('remoteParticipantAudio');
            ele.muted = !this.localControls.audio;
            this.localControls.audio = !this.localControls.audio;
        },
        disableLocalVideo() {
            this.videoRoom.localParticipant.videoTracks.forEach(publication => {
                !this.localControls.video ? publication.track.disable() : publication.track.enable();
            });
            this.localControls.video = !this.localControls.video;
        },
        async switchCamera() {
            (this.cameraMode == 'user') ? this.cameraMode = 'environment': this.cameraMode = 'user';
            this.videoRoom.localParticipant.videoTracks.forEach(publication => {
                publication.track.restart({
                    facingMode: this.cameraMode
                })
            })
        },
        onCHat() {
            this.minimized = !this.minimized;
        },
        changeMinimized() {
            this.minimized = !this.minimized;
            this.$parent.$emit('minimized')
            this.$store.dispatch("SET_VIDEO_LAYOUT");
        },
        minMaxPanel() {
            this.isLocalAsPrimary = !this.isLocalAsPrimary
        }
    }
}
</script>
